var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 10.3765V36.8867C37.9999 37.5013 37.5012 38 36.8866 38H5.55371C4.93918 38 4.44043 37.5013 4.44043 36.8867V1.11328C4.44043 0.49875 4.93918 0 5.55371 0H27.4898C27.7822 0 28.0628 0.115039 28.2713 0.320625L37.6682 9.58312C37.8804 9.79242 37.9999 10.0782 37.9999 10.3765Z",
    fill: "#F4F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6682 9.58312L28.2714 0.320625C28.0628 0.115039 27.7823 0 27.4899 0H21.2202V38H36.8867C37.5012 38 38 37.5013 38 36.8867V10.3765C38 10.0782 37.8805 9.79242 37.6682 9.58312Z",
    fill: "#ECEAE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9999 10.3765V11.4898H29.7156C27.8742 11.4898 26.3765 9.99133 26.3765 8.14996V0H27.4897C27.7822 0 28.0627 0.115039 28.2713 0.320625L37.6681 9.58312C37.8804 9.79242 37.9999 10.0782 37.9999 10.3765Z",
    fill: "#E7DFDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4249 15.3392V27.0279C23.4249 30.2654 20.7909 32.8994 17.5535 32.8994H5.87145C2.63402 32.8994 0 30.2654 0 27.0279V15.3392C0 12.1018 2.63402 9.46777 5.87145 9.46777H17.5535C20.7909 9.46777 23.4249 12.1018 23.4249 15.3392Z",
    fill: "#395CD6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5534 9.46777H11.7124V32.8994H17.5534C20.7908 32.8994 23.4249 30.2654 23.4249 27.0279V15.3392C23.4249 12.1018 20.7908 9.46777 17.5534 9.46777Z",
    fill: "#395CD6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.931 18.4625L12.4997 15.0311C12.291 14.8223 12.0077 14.7051 11.7125 14.7051C11.4173 14.7051 11.134 14.8223 10.9253 15.0312L7.49405 18.4625C7.05928 18.8973 7.05928 19.6022 7.49405 20.0369C7.92875 20.4717 8.63368 20.4717 9.06845 20.0369L10.5993 18.5061V26.5913C10.5993 27.2061 11.0977 27.7046 11.7126 27.7046C12.3274 27.7046 12.8259 27.2061 12.8259 26.5913V18.506L14.3568 20.0369C14.5741 20.2543 14.8591 20.363 15.1439 20.363C15.4288 20.363 15.7138 20.2543 15.9311 20.0369C16.3659 19.6021 16.3659 18.8972 15.931 18.4625Z",
    fill: "#F4F1F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9309 18.4625L12.4996 15.0311C12.2909 14.8223 12.0076 14.7051 11.7124 14.7051V27.7045C12.3272 27.7045 12.8257 27.206 12.8257 26.5912V18.506L14.3566 20.0369C14.574 20.2543 14.8589 20.363 15.1438 20.363C15.4286 20.363 15.7136 20.2543 15.9309 20.0369C16.3658 19.6021 16.3658 18.8972 15.9309 18.4625Z",
    fill: "#E7DFDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.0e3ae77999eed57075b81c504bab044b.svg";
export { ForwardRef as ReactComponent };